type InputData = Array<{
  id: string;
  label: string;
  type: string;
}>;

export const createKeyValuePairs = (inputData: InputData) => {
  const keyValuePairs: Record<string, string> = {};

  inputData.forEach((field) => {
    keyValuePairs[field.id] = '';
  });

  return keyValuePairs;
};

export const getIdealImageSize = (width: number | 'auto', height: number | 'auto') => {
  const heightValue = height === 'auto' ? 'auto' : `${height}`;
  const widthValue = width === 'auto' ? 'auto' : `${width}`;
  return `Ideal size: ${widthValue} * ${heightValue}`;
};
